import { useEffect, useState } from 'react';
import { http } from '@/lib/api';

// Single client-side accessor for the app's prices. Fetches /api/pricing once
// (the backend's single source of truth) and caches it across the session so
// every price on the app reads from one place and can never drift again.
let _cache = null;
let _inflight = null;

export function usePricing() {
  const [pricing, setPricing] = useState(_cache);

  useEffect(() => {
    if (_cache) { setPricing(_cache); return; }
    if (!_inflight) {
      _inflight = http.get('/pricing')
        .then((r) => { _cache = r.data; return r.data; })
        .catch(() => null)
        .finally(() => { _inflight = null; });
    }
    let mounted = true;
    _inflight.then((d) => { if (mounted && d) setPricing(d); });
    return () => { mounted = false; };
  }, []);

  return pricing;
}
